import QueryProvider from 'global/QueryProvider';
import { useQuery } from '@tanstack/react-query';

import tradingApi from 'lib/api/trade';

import { InProgressCard, DefaultCard } from './Card';
import { PROGRESS_STATUS_ENUM } from '../constants';

interface ProgressProps {
  children: React.ReactNode;
}

function ProgressGuard({ children }: ProgressProps) {
  const {
    isLoading,
    error: errorPersonal,
    data: queryDataPersonal,
  } = useQuery({
    queryKey: ['tradingProfilePersonal'],
    queryFn: tradingApi.getTradingProfilePersonal,
  });

  if (isLoading || errorPersonal || queryDataPersonal?.status !== 200) {
    return <DefaultCard />;
  }

  const {
    data: { data: resultPersonal },
  } = queryDataPersonal;
  const showInProgress =
    resultPersonal?.status?.enum === PROGRESS_STATUS_ENUM.in_progress;

  if (showInProgress) {
    return <InProgressCard />;
  }

  return <>{children}</>;
}

export default ProgressGuard;
